import React, { useEffect, useState, useRef } from "react";
import Image from "../../img/Image.png";
import "../../styles/index.css";
import { NewFooter } from "../../components/newFooter";
import { motion } from "framer-motion";

import {
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBInputGroup,
  MDBContainer, MDBRow, MDBCol
} from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux"
import { addEmailRecipient } from "../../features/emailCollection/emailCollectionSlice"
import image from "../../img/bladderPainOriginal.png";
import image1 from "../../img/NewIconIncontinence.png";
import image2 from "../../img/NewIconConstipation.png";
import image3 from "../../img/NewIconEndometriosis.png";
import image4 from "../../img/NewIconMenopause.png";
import DownArrow from "../../img/down-arrow.png";
import UpArrow from "../../img/up-arrow.png";
import women from "../../img/image3women.png";
import womenHeart from "../../img/imageHeartWoman.png";
import { element } from "prop-types";


export function OldIndividualPage() {
  const [button1, setButton1] = useState(false);

  const [newsletterEmail, setNewsletterEmail] = useState("")

  //here we have all the functoions and state for the carousel 
  const [width, setWidth] = useState(0)
  const carousel = useRef()

  // useEffect(() => {
  //   console.log(carousel.current.offsetWidth)
  //   setWidth(carousel.current.scrollWidth - carousel.current.offsetWidth)
  // }, [])


  const sliderLeft = () => {
    let slice = document.querySelector("#slider")
    console.log("scrollLeft",slice)
    slice.scrollLeft = slice.scrollLeft - 500
  }

  const sliderRight = () => {
    let slice = document.querySelector("#slider")
    console.log("scrollLeft",slice)
    slice.scrollLeft = slice.scrollLeft + 500
  }



  //and here end the carousel 
  const dispatch = useDispatch()

  const addEmailToNewsletterList = (email) => {
    dispatch(addEmailRecipient({ "email": email }))
    setNewsletterEmail("")
  }

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });

  const countries = [
    "United States",
    "United Kingdom"
  ]

  return (
    <div className="">
      <div className="bgpurple">
        <div className="intro row d-grid">
          <h1 className="col-sm title-res"><bold>We’re so glad you’re here.</bold> </h1>
          <h4 className="introtitle p-1 col-sm text-dm">
            Elana is changing a generation of women’s health, putting you in
            control <br />
            of managing your pelvic health, how, and when, it suits you.
          </h4>
        </div>
        <div className="tag-div">
          <a href="https://www.myelana.com/post/what-is-pelvic-health" target="_blank" className="brand-bg-purple-a2 border-0 a-tag tag-buttom text-dm">WHAT IS PELVIC HEALTH?</a>
        </div>
      </div>
      <div className="d-flex row">
        <div className="col-sm-12 col-md-6 p-0">
          <img src={Image} className="w-res" alt=""></img>
        </div>
        <div className="col-sm-12 col-md-6 pl-4 padi centered">
          <div className="margin-list">
            <div className="white-space">
              <h3 className="title-1 mb-3 text-al center-text-responsive">Health providers on Elana include:</h3>
            </div>

            <ul type="none" className="list col-sm p-0">
              <li className="fs-20 text-dm fw-lighter">Yoga Instructors</li>
              <li className="fs-20 text-dm fw-lighter">Pilates Instructors</li>
              <li className="fs-20 text-dm fw-lighter">Physical Therapy</li>
              <li className="fs-20 text-dm fw-lighter">Pain Management</li>
              <li className="fs-20 text-dm fw-lighter">Health Coach</li>
              <li className="fs-20 text-dm fw-lighter">Gynecologist</li>
              <li className="fs-20 text-dm fw-lighter">and more!</li>
            </ul>
            <div className="center-div-button">
              {/* <Link to="/ChoosingACategory" className="link-individual">
                <button className="buttonmainpageindividual col-sm blue-hover mb-2 tag-buttom text-dm">
                  BROWSE PRACTITIONERS
                </button>
              </Link> */}
              <p className='text-dm fs-20'>Connecting with Practitioners coming soon!</p>
            </div>
          </div>
        </div>
      </div>
      <div className="homepage-banner-9">
        <h1 className="pt-5 px-1 text-center ">
          <bold className="title-responsive-buble">Health providers on Elana include:</bold>
        </h1>
        <div className="py-5">
          <MDBRow className="d-flex justify-content-evenly">
            <MDBCol md="3">
              <div className="d-flex banner-2-circle-1">
                <MDBCard
                  className="brand-bg-purple-2 perfect-circle-individual"

                >
                  <MDBCardBody className="d-flex align-items-center justify-content-center">
                    <MDBCardText className="text-center text-al ">
                      <span className="fs-24 text-dark ">Yoga Instructors</span>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </div>
            </MDBCol>
            <MDBCol md="3">
              <div className="d-flex banner-2-circle-2">
                <MDBCard
                  className="brand-bg-purple-2 perfect-circle-individual"

                >
                  <MDBCardBody className="d-flex align-items-center justify-content-center">
                    <MDBCardText className="text-center text-al">
                      <span className="fs-24 text-dark">Pilates Instructors</span>

                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </div>
            </MDBCol>
            <MDBCol md="3">
              <div className="d-flex banner-2-circle-3">
                <MDBCard
                  className="brand-bg-purple-2 perfect-circle-individual"

                >
                  <MDBCardBody className="d-flex align-items-center justify-content-center">
                    <MDBCardText className="text-center text-al buble-title">
                      <span className="fs-24 text-dark">Physical Therapy</span>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </div>
            </MDBCol>
            <MDBCol md="3">
              <div className="d-flex banner-2-circle-4">
                <MDBCard
                  className="brand-bg-purple-2 perfect-circle-individual"

                >
                  <MDBCardBody className="d-flex align-items-center justify-content-center">
                    <MDBCardText className="text-center text-al">
                      <span className="fs-24 text-dark">Pain Management</span>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </div>
            </MDBCol>
            <MDBCol md="3">
              <div className="d-flex banner-2-circle-1">
                <MDBCard
                  className="brand-bg-purple-2 perfect-circle-individual"

                >
                  <MDBCardBody className="d-flex align-items-center justify-content-center">
                    <MDBCardText className="text-center text-al ">
                      <span className="fs-24 text-dark ">Health Coach</span>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </div>
            </MDBCol>
            <MDBCol md="3">
              <div className="d-flex banner-2-circle-2">
                <MDBCard
                  className="brand-bg-purple-2 perfect-circle-individual"

                >
                  <MDBCardBody className="d-flex align-items-center justify-content-center">
                    <MDBCardText className="text-center text-al">
                      <span className="fs-24 text-dark">Gynecologist</span>

                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </div>
            </MDBCol>
            <MDBCol md="3">
              <div className="d-flex banner-2-circle-1">
                <MDBCard
                  className="brand-bg-purple-2 perfect-circle-individual"

                >
                  <MDBCardBody className="d-flex align-items-center justify-content-center">
                    <MDBCardText className="text-center text-al ">
                      <span className="fs-24 text-dark ">And more</span>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </div>
            </MDBCol>
          </MDBRow>
        </div>
        <h3 className="pt-4 pb-5 text-center fs-24 text-al hidden">
          Pain is never normal. Many women suffer in silence.
        </h3>
      </div>

      {/* ////////////////////////////carrousel//////////////////////////////////////////////////// */}
      <div className="bg-carousel">
        <div className="padding-controller">
          <h2 className="text-center title-carousel">Need help healing now? Or want to prevent issues in the future</h2>
          <p className="text-center paragraph-carousel">Elana brings you a team of pelvic care specialists, education, and products, <br />whenever and wherever works for you</p>
        </div>
        {/*ref={carousel} drag="x" dragConstraints={{ right: 0, left: -width }}  */}
        <div onClick={sliderLeft}><i class="fas fa-chevron-left"></i></div>
        <motion.div className="carousel" id="slider"  >
          <motion.div className="inner-carousel">
            <motion.div className="item position-relative">
              <h3 className="text-center">test</h3>
              <img src={image} className="position-absolute top-50 start-50 translate-middle"></img>
            </motion.div>
            <motion.div className="item position-relative">
              <h3 className="text-center">test</h3>
              <img src={image1} className="position-absolute top-50 start-50 translate-middle"></img>
            </motion.div>
            <motion.div className="item position-relative">
              <h3 className="text-center">test</h3>
              <img src={image2} className="position-absolute top-50 start-50 translate-middle"></img>
            </motion.div>
            <motion.div className="item position-relative">
              <h3 className="text-center">test</h3>
              <img src={image3} className="position-absolute top-50 start-50 translate-middle"></img>
            </motion.div>
            <motion.div className="item position-relative">
              <h3 className="text-center">test</h3>
              <img src={image4} className="position-absolute top-50 start-50 translate-middle"></img>
            </motion.div>
            <motion.div className="item position-relative">
              <h3 className="text-center">test</h3>
              <img src={image2} className="position-absolute top-50 start-50 translate-middle"></img>
            </motion.div>
            <motion.div className="item position-relative">
              <h3 className="text-center">test</h3>
              <img src={image3} className="position-absolute top-50 start-50 translate-middle"></img>
            </motion.div>
            <motion.div className="item position-relative">
              <h3 className="text-center">test</h3>
              <img src={image4} className="position-absolute top-50 start-50 translate-middle"></img>
            </motion.div>
            <motion.div className="item position-relative">
              <h3 className="text-center">test</h3>
              <img src={image2} className="position-absolute top-50 start-50 translate-middle"></img>
            </motion.div>
            <motion.div className="item position-relative">
              <h3 className="text-center">test</h3>
              <img src={image3} className="position-absolute top-50 start-50 translate-middle"></img>
            </motion.div>
            <motion.div className="item position-relative">
              <h3 className="text-center">test</h3>
              <img src={image4} className="position-absolute top-50 start-50 translate-middle"></img>
            </motion.div>
           
          </motion.div>
        </motion.div>
        <div onClick={sliderRight} id="right"><i class="fas fa-chevron-right" ></i></div>
        <div className="d-flex justify-content-center mt-5">
          <div className="bg-drop border-end">
            <h6 className="text-drop">I’d like to:</h6>
          </div>
          <div>
            <div className="">
              <button
                onClick={() => setButton1(!button1)}
                type="button"
                className="bg-drop-arrow"
              >
                <span className="text-black text-dm">Sign up for the waitlist</span>
                {button1 === false ? (
                  <img src={DownArrow} alt="arrow" />
                ) : (
                  <img src={UpArrow} alt="arrow" />
                )}
              </button>
              {button1 && (
                <div>
                  {countries.map((item, index) => {
                    return (
                      <div key={index} className="">
                        <input type="checkbox" className="checkbox-squer m-0" />
                        <p className="m-0 ms-2 text-dm">{item}</p>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* ////////////////////////////blog//////////////////////////////////////////////////// */}

      <div>

        {/* ////blog 1 */}
        <div className="d-flex centered">
          <div className="p-text-contolled">
            <h1>Let’s Talk about Your Needs</h1>
            <p className="text-break">For far too long we’ve accepted women's healthcare that doesn’t really address our needs, especially when it comes to pelvic care.</p>
          </div>
          <div className="">
            <img src={women} className="w-40"></img>
          </div>
        </div>

        {/* ////blog 2 */}
        <div className="d-flex centered bg-light">
          <div className="">
            <img src={womenHeart} className="w-60"></img>
          </div>
          <div className="p-text-contolled w-40">
            <p className="text-break">Elana’s personalized expert approach is designed to transform your standard of care and offer you options that bring confidence and happiness. </p>
            <p className="text-break">Discover pelvic care with Elana. Get information, products, and practitioners that can help you on your pelvic care journey.  </p>
          </div>
        </div>

      </div>

      {/* //////////////circles//////////////////// */}
      <div className="bg-circle">
        <div className="pt-4">
          <h2 className="text-center">Elana’s Personalized Approach to Care</h2>
          <h6 className="text-center">Coming soon</h6>
        </div>
        <div className="center-cricles">
          <div>
            <MDBContainer>
              <MDBRow>
                <div className="circle-indivudial-two">
                  <MDBCol className=""><h6>First in DOM, no order applied</h6></MDBCol>
                </div>
                <div className="circle-indivudial-two">
                  <MDBCol className=""><h6>First in DOM, no order applied</h6></MDBCol>
                </div>
                <div className="circle-indivudial-two">
                  <MDBCol className=""><h6>First in DOM, no order applied</h6></MDBCol>
                </div>
                <div className="circle-indivudial-two">
                  <MDBCol className=""><h6>First in DOM, no order applied</h6></MDBCol>
                </div>
                <div className="circle-indivudial-two">
                  <MDBCol className=""><h6>First in DOM, no order applied</h6></MDBCol>
                </div>
              </MDBRow>
            </MDBContainer>
          </div>
        </div>
      </div>

      {/* ////////////////carousel two ///////////////////// */}
      <div className="carouselTwo">

      </div>


      <div className="individual-page-banner-3 p-5 padding-galaxy-cta">
        <h1 className=" text-center text-al fs-34-24 text-black">
          Connect with the ELANA community, we’ll only send you the important
          stuff.
        </h1>
        <h3 className="text-center text-al fs-24-20 text-black">
          Get updates and the latest info on pelvic care delivered to your
          inbox.
        </h3>
        <div className="d-flex justify-content-center">
          <MDBInputGroup className="email-width mt-3">
            <input
              className="text-dm text-spacing-minus-1 form-control p-2"
              placeholder="Enter your email"
              type="text"
              value={newsletterEmail}
              onChange={(e) => {
                setNewsletterEmail(e.target.value)
              }}
            />
            {windowDimensions.width > 500 ? <button onClick={() => addEmailToNewsletterList(newsletterEmail)} className="brand-bg-purple p-2 border-0 text-white rounded-end blue-hover text-dm">STAY IN THE KNOW</button> : <button onClick={() => addEmailToNewsletterList(newsletterEmail)} className="brand-bg-purple p-2 border-0 text-white rounded-end blue-hover px-4 text-dm">JOIN</button>}
          </MDBInputGroup>
        </div>
        <h5 className="px-5 text-center text-dm text-spacing-minus-1 fs-16 fw-lighter hidden mt-5 text-black">
          Disclaimer: The information provided through Elana Health website and
          services is not intended
          <br />
          or implied to be a substitute for professional medical advice,
          diagnosis or treatment.
        </h5>
      </div>
      <NewFooter />
    </div>
  );
}
